// extracted by mini-css-extract-plugin
export default {"ticketPage":"_TicketPage_ticketPage__sTQNm","ticket__title":"_TicketPage_ticket__title__Mr-hE"};